import { BusinessPartner } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0460. 取引先編集
 * [PUT] /workspaces/:identifier/business_partners/:id
 */
type Props = {
  identifier: string;
  id: number;
  name: string;
  display_name: string;
  description: string;
  business_partner_context_id: number;
  corporate_number: string;
  display_type: 'both' | 'sales' | 'purchase';
};

const updateBusinessPartner = (props: Props): Promise<BusinessPartner> => {
  return axios.put(`/api/workspaces/${props.identifier}/business_partners/${props.id}`, props);
};

export const useUpdateBusinessPartner = () => {
  return useMutation({
    mutationFn: updateBusinessPartner,
  });
};
